import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AutoLayoutButton, CursorModeToggle, FitViewButton, FlowToolbar, FlowToolbarDivider, UndoRedoButtons } from "../flow-kit";
export function ProcessFlowBottomToolbar({ onAutoLayout, onUndo, onRedo, canUndo, canRedo, cursorMode, onCursorModeChange, children }) {
    return /*#__PURE__*/ _jsxs(FlowToolbar, {
        children: [
            onCursorModeChange && /*#__PURE__*/ _jsx(CursorModeToggle, {
                value: cursorMode ?? "pan",
                onChange: onCursorModeChange
            }),
            /*#__PURE__*/ _jsx(FitViewButton, {}),
            onAutoLayout && /*#__PURE__*/ _jsx(AutoLayoutButton, {
                onClick: onAutoLayout
            }),
            /*#__PURE__*/ _jsx(UndoRedoButtons, {
                onUndo: onUndo,
                onRedo: onRedo,
                canUndo: canUndo,
                canRedo: canRedo
            }),
            children && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(FlowToolbarDivider, {}),
                    children
                ]
            })
        ]
    });
}

//# sourceMappingURL=ProcessFlowBottomToolbar.js.map